import axios from "axios";
import { OpenAPI } from "@propertelligent/client-api";

export interface SingleItemResponse<T> {
  success?: T;
  errors?: Record<string, string[]>;
}

const baseUrl = (): string =>
  typeof OpenAPI.BASE === "string" ? OpenAPI.BASE : "";

const authHeaders = (): Record<string, string> => {
  const token = typeof OpenAPI.TOKEN === "string" ? OpenAPI.TOKEN : undefined;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// TODO(client-api-regen): replace this thin axios wrapper with the generated
// OrganizationTransaction refund method once the backend SDK is republished.
export const refundOrganizationTransaction = async (
  organizationTransactionId: number,
): Promise<SingleItemResponse<string>> => {
  const response = await axios.put(
    `${baseUrl()}/api/OrganizationTransaction/${organizationTransactionId}/refund`,
    null,
    { headers: authHeaders() },
  );

  return response.data;
};
